import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../core/services/network-call.service';
import { HelpersService } from '../../core/services/helpers.service';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

@Injectable()
export class StaticDataComplianceEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helpers: HelpersService
  ) {}

  loadClientTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadClientTypes),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/clientType').pipe(
          map(response => complianceActions.loadClientTypesSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadClientTypesFailure({ error }));
          })
        )
      )
    )
  );

  loadComplianceStatuses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadComplianceStatuses),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/Status').pipe(
          map(response => complianceActions.loadComplianceStatusesSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadComplianceStatusesFailure({ error }));
          })
        )
      )
    )
  );

  loadJurisdictionRisks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadJurisdictionRisks),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/jurisdictionRisk').pipe(
          map(response => complianceActions.loadJurisdictionRisksSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadJurisdictionRisksFailure({ error }));
          })
        )
      )
    )
  );

  loadPepRisks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadPepRisks),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/pepRisk').pipe(
          map(response => complianceActions.loadPepRisksSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadPepRisksFailure({ error }));
          })
        )
      )
    )
  );

  loadMediaRisks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadMediaRisks),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/mediaRisk').pipe(
          map(response => complianceActions.loadMediaRisksSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadMediaRisksFailure({ error }));
          })
        )
      )
    )
  );

  loadValueRisks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(complianceActions.loadValueRisks),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/Compliance/valueRisk').pipe(
          map(response => complianceActions.loadValueRisksSuccess({ response })),
          catchError(error => {
            return of(complianceActions.loadValueRisksFailure({ error }));
          })
        )
      )
    )
  );
}